import { render, staticRenderFns } from "./BtnChooseValid.vue?vue&type=template&id=4ee2499e&"
import script from "./BtnChooseValid.vue?vue&type=script&lang=js&"
export * from "./BtnChooseValid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports